<nav class="side-nav-app">
  <div class="side-nav-app__top">
    <div class="side-nav-app-logo">
      <span><img src="/public/img/admin-logo.svg" alt="" /></span>
    </div>

    <button
      (click)="uiService.toggleNavBarSmall()"
      type="button"
      class="un-btn button-navigation"
      [ngClass]="{ 'button-navigation--close': uiService.navBarSmall }"
      title="Menu app"
    >
      <i class="glicon-burger-menu"></i>
    </button>
  </div>

  <ul class="list-nav">
    <li *ngFor="let route of navigationRoutes" class="list-nav-item" [ngClass]="route.class">
      <ng-container *ngIf="!route.navigation_menu; then option; else submenu"></ng-container>
      <ng-template #option>
        <a
          class="list-nav-link"
          routerLinkActive="active"
          [ngClass]="route.class"
          [routerLink]="[route.route]"
          title="{{ uiService.navBarSmall ? (route.label | translate) : '' }}"
          *lmsProfileGuard="route.action"
        >
          <i class="{{ route.icon }}"></i>
          <span>{{ route.label | translate }}</span>
        </a>
      </ng-template>
      <ng-template #submenu>
        <a
          class="list-nav-link list-nav-link--withchilds"
          [ngClass]="{ active: route.active }"
          *lmsProfileGuard="route.action"
          (click)="route.active = !route.active"
          title="{{ uiService.navBarSmall ? (route.label | translate) : '' }}"
        >
          <i class=" {{ route.icon }}"></i>
          <span>{{ route.label | translate }}</span>
          <i class="glicon-down-arrow" [ngClass]="{ 'list-nav-link__toggle': submenu }"></i>
        </a>
        <ul>
          <li *ngFor="let childRoute of route.navigation_menu">
            <a
              class="list-nav-link list-nav-link--indent"
              routerLinkActive="active"
              [ngClass]="childRoute.class"
              [routerLink]="[childRoute.route]"
              *lmsProfileGuard="childRoute.action"
              title="{{ uiService.navBarSmall ? (childRoute.label | translate) : '' }}"
            >
              <i class=" {{ childRoute.icon }}"></i>
              <span>{{ childRoute.label | translate }}</span>
            </a>
          </li>
        </ul>
      </ng-template>
    </li>
  </ul>
  <div class="nav-logo"></div>
</nav>
